export const rptJobSkillsList = (jobList, skillsList) =>{
    let rptArr = [];
    let skillsColumns = [];
    for (let i=0; i<skillsList.length; i++){
        let skillParameter = "skill" + skillsList[i].questionNbr;
        const colHeading = { [skillParameter]: skillsList[i].skillName};
        skillsColumns.push(colHeading);
    } 
    const skillsColumnHeadings = Object.assign({}, ...skillsColumns);
    for (let i=0; i<jobList.length; i++){
        if (i === 0){
            const rptArrObj = {jobID: "jobID", jobName: "Job Name",
                jobDesc:  "Job Description", ...skillsColumnHeadings}
            rptArr.push(rptArrObj);
        }
        const jobSkills = jobList[i].requiredSkills;
        let skillValues = [];
        for (let j=0; j<jobSkills.length; j++){
            let skillParameter = "skill" + skillsList[j].questionNbr;
            const skillValueObj = { [skillParameter]: jobSkills[j]};
            skillValues.push(skillValueObj);
        } 
        const jobSkillValues = Object.assign({}, ...skillValues);
        let rptLine = {jobID: jobList[i].id, jobName: jobList[i].jobName,
            jobDesc: jobList[i].description, ...jobSkillValues }
        rptArr.push(rptLine);
    }
    return rptArr;
}
export default rptJobSkillsList;